module.exports = __webpack_public_path__ + "static/media/18.74f134a2.png";